// extracted by mini-css-extract-plugin
export var boxContentPin = "box-content-pin-module--boxContentPin--9f9a9";
export var boxContentPin__img = "box-content-pin-module--boxContentPin__img--9ad23";
export var boxContentPin__tooltip = "box-content-pin-module--boxContentPin__tooltip--f2d73";
export var isVisible = "box-content-pin-module--isVisible--f2a05";
export var pulseRing = "box-content-pin-module--pulse-ring--1f31c";